import React from "react";
import Box from "@mui/material/Box";

import { Icon } from "components";
import { useProgressiveImage } from "hooks";

const ProgressiveImage = ({ src, alt, wrapperProps, classes, selectedId, testId = "", meta = {} }) => {
  // const [isErr, setIsErr] = useState(false);
  const { isLoading } = useProgressiveImage(src);

  const onPhotoClick = () => {
    const eventHash = {
      event_name: "h_click",

      event_params: {
        h_page_type: "hayley",
        h_display_method: "iframe",
        h_clicked_location: `${selectedId} photo`,
        h_click_value: alt,
      },
    };

    window.parent.postMessage(JSON.stringify(eventHash), "*");
  };

  return (
    <Box className={classes.root} {...wrapperProps}>
      <Box data-testid={testId} className="hayley-h-full hayley-w-full" onClick={onPhotoClick}>
        <img
          src={src}
          className={`${classes.img ? classes.img : "hayley-h-full hayley-w-full hayley-object-cover hayley-object-center"} ${
            isLoading ? "hayley-bg-gray-300 hayley-blur-2xl" : "hayley-blur-none"
            // } ${isErr ? "hayley-hidden" : "hayley-block"}`}
          } ${!src ? "hayley-hidden" : "hayley-block"}`}
          alt={alt}
          // onError={() => setIsErr(true)}
          {...(meta ? { "data-width": meta.image_width, "data-height": meta.image_height } : {})}
        />
        {/* {isErr && ( */}
        {!src && (
          <Box className="hayley-left-0 hayley-top-0 hayley-flex hayley-h-full hayley-w-full hayley-items-center hayley-justify-center hayley-bg-gray-100">
            <Icon iconType="FloorPlanPlaceholder" className="hayley-aspect-square hayley-h-1/2 hayley-text-gray-300" />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default React.memo(ProgressiveImage);
